import React, { useEffect, useRef, useState } from "react";
import { getBookingDetails } from "../mytrips/services/mytrips.services";
import Loading from "../../components/spinner/Loading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useLocation, useNavigate } from "react-router";
import moment from "moment";
import { ErrorToast } from "../../toast/Toasts";
import {
  CancelCode,
  CancellationType,
  MAIN_GST_PER,
  ReqRemarks,
} from "../../_constants/constant";
import { groupBy } from "lodash";
import {
  addCancelBooking,
  bookingCancel,
} from "./services/bookingcancellation.services";
import {
  getChargesByMembershipPlan,
  getHandlingFees,
} from "../reviewbooking/services/reviewbooking.services";
import { addCancellationCharge } from "../../_helpers/fareUtils";
import { getLocalItem } from "../../_helpers/storageUtils";

const BookingCancellation = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state?.mytrips?.loading);
  const fetchLoading = useAppSelector(
    (state) => state?.bookingcancellation?.loading
  );
  const location = useLocation();
  const navigate = useNavigate();
  const closeBtnRef = useRef<any>(null);

  const params = new URLSearchParams(location.search);
  const bookingId = params.get("bookingId");
  const isFullCancel = params.get("isfull") === "1";

  const BookingDetails = useAppSelector(
    (state) => state?.mytrips?.BookinDetails
  );

  const handlingFees = useAppSelector(
    (state) => state.reviewbooking.handlingFees
  );

  const adminCharges = useAppSelector(
    (state) => state.reviewbooking.adminCharges
  );

  const [checkList, setCheckList] = useState<any[]>([]);
  const [paxDetails, setPaxDetails] = useState<any[]>([]);

  const groupedCheckList = groupBy(checkList, "TripIndex");

  const baseCancellationFee =
    BookingDetails?.Travel_Type === 1
      ? adminCharges?.InternationalCancellationCharge || 0
      : adminCharges?.DomesticCancellationCharge || 0;

  const cancellationChargeGSTPer = handlingFees?.GSTPer || MAIN_GST_PER;

  const gstAmount = (baseCancellationFee * cancellationChargeGSTPer) / 100;
  const cancellationFeeWithGST = baseCancellationFee + gstAmount;

  const updatedPaxDetails = addCancellationCharge(
    paxDetails,
    cancellationFeeWithGST,
    cancellationChargeGSTPer
  );

  const handleCheckAll = (tripIndex: number, paxList: any[]) => {
    const currentPaxDetails: any[] = [];
    const allSegments = paxList.flatMap((pax) => {
      const PassangerName = `${pax?.Title} ${pax?.First_Name} ${pax?.Last_Name}`;
      const paxType = pax?.Pax_type;
      return pax?.TicketDetails?.flatMap((ticket: any) => {
        const ticket_no = ticket?.Ticket_Number;
        const segments = ticket?.SegemtWiseChanges?.filter(
          (e: any) => e?.CancelRequestId === "0" && e?.CancelStatus === "LIVE"
        )?.map((segment: any) => ({
          FlightId: ticket?.Flight_Id,
          PassengerId: pax.Pax_Id?.toString(),
          SegmentId: segment?.Segement_Id,
          TripIndex: tripIndex,
          ticket_no: ticket?.Ticket_Number,
        }));

        if (segments?.length && ticket_no) {
          currentPaxDetails.push({
            ticket_no,
            journey_type: tripIndex === 0 ? "Onward" : "Return",
            cancellation_charge: 0,
            cancellation_gst_per: 0,
            passanger_name: PassangerName,
            paxType,
            status: "Tocancel",
          });
        }

        return segments;
      });
    });

    const allSelected = allSegments.every((segment) =>
      checkList.some(
        (checked) =>
          checked.FlightId === segment.FlightId &&
          checked.PassengerId === segment.PassengerId &&
          checked.SegmentId === segment.SegmentId &&
          checked.TripIndex === segment.TripIndex
      )
    );

    if (allSelected) {
      setCheckList(checkList.filter((item) => item.TripIndex !== tripIndex));

      setPaxDetails((prev) =>
        prev.filter(
          (num) =>
            !currentPaxDetails.find(
              (newItem) => newItem.ticket_no === num.ticket_no
            )
        )
      );
    } else {
      const filteredCheckList = checkList.filter(
        (item) => item.TripIndex !== tripIndex
      );
      setCheckList([...filteredCheckList, ...allSegments]);

      setPaxDetails((prev) => {
        const uniqueNumbers = new Map();
        [...prev, ...currentPaxDetails].forEach((item) => {
          uniqueNumbers.set(item.ticket_no, item);
        });
        return Array.from(uniqueNumbers.values());
      });
    }
  };
  const handleCheck = (
    tripIndex: number,
    pax: any,
    flightId: string,
    segments: string[]
  ) => {
    const segmentItems = segments.map((segmentId) => ({
      FlightId: flightId,
      PassengerId: pax.Pax_Id?.toString(),
      SegmentId: segmentId,
      TripIndex: tripIndex,
      ticket_no: pax?.TicketDetails[0]?.Ticket_Number,
    }));

    const PassangerName = `${pax?.Title} ${pax?.First_Name} ${pax?.Last_Name}`;
    const paxType = pax?.Pax_type;

    const paxDetailsToToggle =
      pax?.TicketDetails?.map((ticket: any) =>
        ticket?.Ticket_Number
          ? {
              ticket_no: ticket.Ticket_Number,
              journey_type: tripIndex === 0 ? "Onward" : "Return",
              cancellation_charge: 0,
              cancellation_gst_per: 0,
              passanger_name: PassangerName,
              paxType,
              status: "Tocancel",
            }
          : null
      ).filter(Boolean) || [];

    const allSegmentsExist = segmentItems.every((item) =>
      checkList.some(
        (checked) =>
          checked.FlightId === item.FlightId &&
          checked.PassengerId === item.PassengerId &&
          checked.SegmentId === item.SegmentId &&
          checked.TripIndex === item.TripIndex
      )
    );

    if (allSegmentsExist) {
      setCheckList(
        checkList.filter(
          (checked) =>
            !segmentItems.some(
              (item) =>
                item.FlightId === checked.FlightId &&
                item.PassengerId === checked.PassengerId &&
                item.SegmentId === checked.SegmentId &&
                item.TripIndex === checked.TripIndex
            )
        )
      );

      setPaxDetails((prev) =>
        prev.filter(
          (num) =>
            !paxDetailsToToggle.find((t: any) => t.ticket_no === num.ticket_no)
        )
      );
    } else {
      setCheckList([...checkList, ...segmentItems]);

      setPaxDetails((prev) => {
        const unique = new Map();
        [...prev, ...paxDetailsToToggle].forEach((item) => {
          unique.set(item.ticket_no, item);
        });
        return Array.from(unique.values());
      });
    }
  };

  const handleCancelBooking = async () => {
    const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));

    const successfulPax: any[] = [];

    await Promise.allSettled(
      Object.entries(groupedCheckList).map(
        async ([tripIndex, details]: any, index: number) => {
          await delay(index * 500);

          const payload = {
            AirTicketCancelDetails: details.map((item: any) => {
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
              const { TripIndex, ...rest } = item;
              return rest;
            }),
            Airline_PNR: "",
            RefNo: BookingDetails?.portal_booking_no,
            CancelCode: CancelCode,
            ReqRemarks: ReqRemarks,
            CancellationType: CancellationType,
          };

          const res = await dispatch(bookingCancel(payload));

          if (res.payload?.Response_Header?.Error_Code === "0000") {
            const matchingTickets = details.map((item: any) => item.ticket_no);
            const successPax = paxDetails.filter((p: any) =>
              matchingTickets.includes(p.ticket_no)
            );
            successfulPax.push(...successPax);
          } else {
            ErrorToast(
              `Cancellation failed for ${
                tripIndex === "0" ? "Onward" : "Return"
              } Journey`
            );
          }
        }
      )
    );

    if (successfulPax.length > 0) {
      const baseCancellationFee =
        BookingDetails?.Travel_Type === 1
          ? adminCharges?.InternationalCancellationCharge || 0
          : adminCharges?.DomesticCancellationCharge || 0;

      const cancellationChargeGSTPer = handlingFees?.GSTPer || MAIN_GST_PER;

      const gstAmount = (baseCancellationFee * cancellationChargeGSTPer) / 100;
      const cancellationFeeWithGST = baseCancellationFee + gstAmount;

      const updatedPaxDetails = addCancellationCharge(
        successfulPax,
        cancellationFeeWithGST,
        cancellationChargeGSTPer
      );

      const user_guid = getLocalItem("user_guid");

      const dbPayload = {
        booking_no: BookingDetails?.Booking_RefNo,
        portal_booking_no: BookingDetails?.portal_booking_no,
        user_type: "User",
        user_guid: user_guid,
        pax_detail: updatedPaxDetails,
      };

      const response = await dispatch(addCancelBooking(dbPayload));

      if (closeBtnRef.current) {
        closeBtnRef.current.click();
      }

      if (response.meta.requestStatus === "fulfilled") {
        navigate(
          `/flights/cancel-confirmation?bookingId=${BookingDetails?.portal_booking_no}`
        );
      } else {
        ErrorToast(
          "Booking cancelled but failed to save in DB. Contact support."
        );
        console.log("ERROR: Adding Cancel Booking in DB");
        navigate(
          `/flights/cancel-confirmation?bookingId=${BookingDetails?.portal_booking_no}`
        );
      }
    } else {
      ErrorToast("Cancellation failed for all passengers. Nothing saved.");
    }
  };

  useEffect(() => {
    return () => {
      if (closeBtnRef.current) {
        closeBtnRef.current.click();
      }
    };
  });

  useEffect(() => {
    dispatch(
      getBookingDetails({
        Booking_RefNo: bookingId,
        Airline_PNR: "",
      })
    );
    dispatch(getChargesByMembershipPlan(getLocalItem("user_guid") || ""));
    dispatch(getHandlingFees());
  }, [bookingId]);

  useEffect(() => {
    if (isFullCancel && BookingDetails?.AirPNRDetails) {
      const newCheckList: any[] = [];
      const newPaxDetails: any[] = [];

      BookingDetails.AirPNRDetails.forEach(
        (tripInfo: any, tripIndex: number) => {
          const paxList = tripInfo?.PAXTicketDetails || [];
          paxList.forEach((pax: any) => {
            if (pax?.TicketStatus === "Live") {
              const PassangerName = `${pax?.Title} ${pax?.First_Name} ${pax?.Last_Name}`;
              const paxType = pax?.Pax_type;
              pax?.TicketDetails?.forEach((ticket: any) => {
                const ticket_no = ticket?.Ticket_Number;
                const segments = ticket?.SegemtWiseChanges?.filter(
                  (e: any) =>
                    e?.CancelRequestId === "0" && e?.CancelStatus === "LIVE"
                )?.map((segment: any) => ({
                  FlightId: ticket?.Flight_Id,
                  PassengerId: pax.Pax_Id?.toString(),
                  SegmentId: segment?.Segement_Id,
                  TripIndex: tripIndex,
                  ticket_no: ticket?.Ticket_Number,
                }));

                if (segments?.length) {
                  newCheckList.push(...segments);
                  newPaxDetails.push({
                    ticket_no,
                    journey_type: tripIndex === 0 ? "Onward" : "Return",
                    cancellation_charge: 0,
                    cancellation_gst_per: 0,
                    passanger_name: PassangerName,
                    paxType,
                    status: "Tocancel",
                  });
                }
              });
            }
          });
        }
      );

      setCheckList(newCheckList);
      setPaxDetails(newPaxDetails);
    }
  }, [isFullCancel, BookingDetails]);

  const mainPax =
    BookingDetails?.AirPNRDetails &&
    BookingDetails?.AirPNRDetails[0] &&
    BookingDetails?.AirPNRDetails[0]?.PAXTicketDetails &&
    BookingDetails?.AirPNRDetails[0]?.PAXTicketDetails[0];

  return (
    <>
      <Loading loading={loading || fetchLoading} backgroundColor="white" />
      {!loading && (
        <div className="cancellation-view">
          <div className="container mt-3">
            <h3 className="mt-4 mb-3 header-label">Booking Cancellation</h3>
            <div className="row">
              <div className="col col-lg-6">
                <div className="info-wrapper">
                  <h4 className="color-darkgreen">
                    {`${mainPax?.Title} ${mainPax?.First_Name} ${mainPax?.Last_Name}`}
                    {/* {BookingDetails?.CustomerDetail?.Customer_Name} */}
                  </h4>
                  <p className="mb-1">
                    <span className="fw-600 color-darkgreen">Mo. no.:</span>{" "}
                    {BookingDetails?.PAX_Mobile}
                  </p>
                  <p className="m-0">
                    <span className="fw-600 color-darkgreen">Email ID: </span>
                    {BookingDetails?.PAX_EmailId}
                  </p>
                </div>
              </div>
              <div className="col col-lg-6">
                <div className="info-wrapper">
                  <p className="mb-2">
                    <span className="fw-600 color-darkgreen">PNR.: </span>
                    {BookingDetails?.AirPNRDetails?.map(
                      (pnrdetails: any, index: number) => {
                        if (index + 1 < BookingDetails?.AirPNRDetails?.length) {
                          return pnrdetails?.Airline_PNR + ", ";
                        } else {
                          return pnrdetails?.Airline_PNR;
                        }
                      }
                    )}
                  </p>
                  <p className="mb-2">
                    <span className="fw-600 color-darkgreen">
                      Booking Ref No.:{" "}
                    </span>
                    {BookingDetails?.portal_booking_no}
                  </p>
                  <p className="mb-2">
                    <span className="fw-600 color-darkgreen">
                      Booking Date:{" "}
                    </span>
                    {moment(
                      BookingDetails?.Booking_DateTime,
                      "DD/MM/YYYY HH:mm:ss"
                    ).format("DD/MM/YYYY | hh:mm:ss A")}
                  </p>
                </div>
              </div>
            </div>
            {BookingDetails &&
              BookingDetails?.AirPNRDetails?.map(
                (tripInfo: any, tripIndex: any) => {
                  const priceDetails =
                    tripInfo?.Flights[0]?.Fares &&
                    tripInfo?.Flights[0]?.Fares[0];

                  const cancellationCharges =
                    (priceDetails?.FareDetails[0] &&
                      priceDetails?.FareDetails[0]?.CancellationCharges) ||
                    [];
                  const rescheduleCharges =
                    (priceDetails?.FareDetails[0] &&
                      priceDetails?.FareDetails[0]?.RescheduleCharges) ||
                    [];

                  if (
                    tripInfo?.PAXTicketDetails?.some(
                      (e: any) => e?.TicketStatus === "Live"
                    )
                  ) {
                    return (
                      <div key={tripIndex}>
                        <div className="mt-4 mb-3 header-label d-flex align-items-center justify-content-between">
                          <h3 className="m-0">
                            {`${
                              (BookingDetails?.Booking_Type === 1 ||
                                BookingDetails?.Booking_Type === 2) &&
                              tripInfo?.Flights?.length > 1
                                ? "Round Trip"
                                : BookingDetails?.AirPNRDetails?.length > 1
                                ? tripIndex === 0
                                  ? "Onward"
                                  : "Return"
                                : ""
                            } Flight & Pax Details`}
                          </h3>
                          <span
                            className="cancellation-farerule-title"
                            data-bs-toggle="modal"
                            data-bs-target={`#farerulepopup_${tripIndex}`}
                          >
                            View Fare Rule
                          </span>
                        </div>
                        <div className="row mt-3">
                          <div className="col-12">
                            <div className="info-wrapper">
                              {tripInfo?.Flights?.flatMap(
                                (
                                  flight: any // TODO check with specialroundtrip cancellation and if needed then change the logic
                                ) =>
                                  flight?.Segments?.map(
                                    (segment: any, index: number) => (
                                      <div
                                        className="route-timing justify-content-between mb-4"
                                        key={index}
                                      >
                                        <div
                                          className="route-strating"
                                          style={{ width: "40%" }}
                                        >
                                          {segment?.Origin}
                                          <span>
                                            {segment?.Origin_Terminal
                                              ? `Terminal : ${segment?.Origin_Terminal}`
                                              : ""}
                                          </span>
                                          <p className="mt-1">
                                            {moment(
                                              segment?.Departure_DateTime,
                                              "MM/DD/YYYY HH:mm:ss"
                                            ).format("ddd, DD MMM. YYYY HH:mm")}
                                          </p>
                                        </div>
                                        <div className="cunsume-time">
                                          <span>
                                            {segment?.Airline_Code +
                                              " - " +
                                              segment?.Flight_Number}
                                          </span>
                                          <div className="position-relative cancellation-cunsume-pic">
                                            <span
                                              style={{
                                                position: "absolute",
                                                right: -3,
                                                top: -10,
                                              }}
                                            >
                                              ►
                                            </span>
                                          </div>
                                        </div>
                                        <div
                                          className="route-strating text-end"
                                          style={{ width: "40%" }}
                                        >
                                          {segment?.Destination}
                                          <span>
                                            {segment?.Destination_Terminal
                                              ? `Terminal : ${segment?.Destination_Terminal}`
                                              : ""}
                                          </span>
                                          <p className="mt-1">
                                            {moment(
                                              segment?.Arrival_DateTime,
                                              "MM/DD/YYYY HH:mm:ss"
                                            ).format("ddd, DD MMM. YYYY HH:mm")}
                                          </p>
                                        </div>
                                      </div>
                                    )
                                  )
                              )}
                              <hr />
                              <table className="cancellation-table">
                                <tr
                                  style={{
                                    background: "#000",
                                    color: "#fff",
                                    textAlign: "center",
                                  }}
                                >
                                  <th>
                                    <div className="sidebar-field m-0">
                                      <input
                                        type="checkbox"
                                        className="m-auto"
                                        onChange={() =>
                                          handleCheckAll(
                                            tripIndex,
                                            tripInfo?.PAXTicketDetails || []
                                          )
                                        }
                                        checked={tripInfo?.PAXTicketDetails?.flatMap(
                                          (pax: any) =>
                                            pax.TicketDetails.flatMap(
                                              (ticket: any) =>
                                                ticket.SegemtWiseChanges?.filter(
                                                  (e: any) =>
                                                    e?.CancelRequestId ===
                                                      "0" &&
                                                    e?.CancelStatus === "LIVE"
                                                )?.map((seg: any) => ({
                                                  FlightId: ticket.Flight_Id,
                                                  PassengerId:
                                                    pax.Pax_Id.toString(),
                                                  SegmentId: seg.Segement_Id,
                                                  TripIndex: tripIndex,
                                                }))
                                            )
                                        )?.every((segment: any) =>
                                          checkList.some(
                                            (checked) =>
                                              checked.FlightId ===
                                                segment.FlightId &&
                                              checked.PassengerId ===
                                                segment.PassengerId &&
                                              checked.SegmentId ===
                                                segment.SegmentId &&
                                              checked.TripIndex ===
                                                segment.TripIndex
                                          )
                                        )}
                                      />
                                    </div>
                                  </th>
                                  <th>Passenger Name</th>
                                  <th>Flight</th>
                                  <th>Fare Type</th>
                                  <th>Add-on Services</th>
                                </tr>
                                {tripInfo?.PAXTicketDetails?.map((pax: any) => {
                                  if (pax?.TicketStatus === "Live") {
                                    return (
                                      pax?.TicketDetails &&
                                      pax?.TicketDetails.map(
                                        (ticketDetail: any) => {
                                          return ticketDetail?.SegemtWiseChanges
                                            ?.length > 0
                                            ? ticketDetail?.SegemtWiseChanges.map(
                                                (
                                                  segment: any,
                                                  index: number,
                                                  array: any[]
                                                ) => {
                                                  return (
                                                    <tr
                                                      key={`${ticketDetail?.Ticket_Number}-${index}`}
                                                    >
                                                      {index === 0 && (
                                                        <>
                                                          <td
                                                            rowSpan={
                                                              array.length
                                                            }
                                                          >
                                                            <div className="sidebar-field m-0">
                                                              <input
                                                                type="checkbox"
                                                                className="m-auto"
                                                                checked={pax.TicketDetails.every(
                                                                  (
                                                                    ticket: any
                                                                  ) =>
                                                                    ticket.SegemtWiseChanges.every(
                                                                      (
                                                                        segment: any
                                                                      ) =>
                                                                        checkList.some(
                                                                          (
                                                                            item
                                                                          ) =>
                                                                            item.PassengerId ===
                                                                              pax.Pax_Id.toString() &&
                                                                            item.FlightId ===
                                                                              ticket.Flight_Id &&
                                                                            item.SegmentId ===
                                                                              segment.Segement_Id
                                                                        )
                                                                    )
                                                                )}
                                                                onChange={() =>
                                                                  handleCheck(
                                                                    tripIndex,
                                                                    pax,
                                                                    ticketDetail.Flight_Id,
                                                                    ticketDetail.SegemtWiseChanges.map(
                                                                      (
                                                                        seg: any
                                                                      ) =>
                                                                        seg.Segement_Id
                                                                    )
                                                                  )
                                                                }
                                                              />
                                                            </div>
                                                          </td>
                                                          <td
                                                            rowSpan={
                                                              array.length
                                                            }
                                                          >
                                                            {`${pax?.Title} ${pax?.First_Name} ${pax?.Last_Name}`}
                                                          </td>
                                                        </>
                                                      )}
                                                      <td className="text-center">
                                                        <p className="m-0">{`${segment?.Origin} - ${segment?.Destination}`}</p>
                                                      </td>
                                                      <td>
                                                        {pax?.Fares[0]
                                                          ?.Refundable
                                                          ? "Refundable"
                                                          : "Non Refundable"}
                                                      </td>
                                                      <td>
                                                        {`${
                                                          (pax?.SSRDetails[
                                                            index
                                                          ] &&
                                                            pax?.SSRDetails[
                                                              index
                                                            ]?.SSR_TypeDesc) ||
                                                          ""
                                                        }`}
                                                      </td>
                                                    </tr>
                                                  );
                                                }
                                              )
                                            : null;
                                        }
                                      )
                                    );
                                  }
                                })}
                              </table>
                            </div>
                          </div>
                        </div>
                        <div
                          className="modal fade"
                          id={`farerulepopup_${tripIndex}`}
                          data-bs-backdrop="static"
                          data-bs-keyboard="false"
                          tabIndex={-1}
                          aria-labelledby="edit-profile"
                          aria-hidden="true"
                        >
                          <div
                            className="modal-dialog modal-dialog-centered"
                            style={{ maxWidth: 991 }}
                          >
                            <div className="modal-content">
                              <div className="modal-header">
                                <h4
                                  className="modal-title fs-5"
                                  id="edit-profile"
                                >
                                  Fare Rule Information
                                </h4>
                                <button
                                  type="button"
                                  className="btn-close"
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                ></button>
                              </div>
                              <div className="modal-body travel-form-detail">
                                {/* <Loading loading={fareRulesLoading} /> */}
                                {cancellationCharges?.length <= 0 &&
                                rescheduleCharges?.length <= 0 ? (
                                  <h4 className="text-center">
                                    Non - Refundable!!!
                                  </h4>
                                ) : (
                                  <div
                                    style={{
                                      maxHeight: "calc(100vh - 300px)",
                                      overflowY: "auto",
                                      scrollbarWidth: "thin",
                                    }}
                                  >
                                    {cancellationCharges?.length > 0 && (
                                      <div className="cancel-wrapper">
                                        <div className="cancel-table-container">
                                          <table className="cancel-table">
                                            <thead>
                                              <tr>
                                                <th
                                                  colSpan={5}
                                                  className="cancel-th"
                                                >
                                                  <h4>Cancellation Charges</h4>
                                                </th>
                                              </tr>
                                              <tr>
                                                <th className="cancel-th">#</th>
                                                <th className="cancel-th">
                                                  Applicability
                                                </th>
                                                <th className="cancel-th">
                                                  Passenger Type
                                                </th>
                                                <th className="cancel-th">
                                                  Duration
                                                </th>
                                                <th className="cancel-th">
                                                  Charge
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {cancellationCharges?.map(
                                                (
                                                  cCharge: any,
                                                  index: number
                                                ) => {
                                                  return (
                                                    <tr className="cancel-row">
                                                      <td className="cancel-td">
                                                        {index + 1}
                                                      </td>
                                                      <td className="cancel-td">
                                                        <span className="cancel-pill">
                                                          Per{" "}
                                                          {cCharge?.Applicablility ===
                                                          0
                                                            ? "Segment"
                                                            : "Passenger"}
                                                        </span>
                                                      </td>
                                                      <td className="cancel-td">
                                                        {cCharge?.PassengerType ===
                                                        0
                                                          ? "Adult"
                                                          : cCharge?.PassengerType ===
                                                            1
                                                          ? "Child"
                                                          : "Infant"}
                                                      </td>
                                                      <td className="cancel-td">
                                                        {cCharge?.DurationFrom}{" "}
                                                        {cCharge?.DurationTypeFrom ===
                                                        0
                                                          ? "Hr(s) "
                                                          : cCharge?.DurationTypeFrom ===
                                                            1
                                                          ? "days "
                                                          : ""}
                                                        – {cCharge?.DurationTo}{" "}
                                                        {cCharge?.DurationTypeTo ===
                                                        0
                                                          ? "Hr(s)"
                                                          : cCharge?.DurationTypeTo ===
                                                            1
                                                          ? "days"
                                                          : ""}
                                                      </td>
                                                      <td className="cancel-td">
                                                        {+cCharge?.Value ===
                                                        0 ? (
                                                          "Non Chargeable"
                                                        ) : +cCharge?.Value ===
                                                            100 &&
                                                          cCharge?.ValueType ===
                                                            1 ? (
                                                          "Non Refundable"
                                                        ) : (
                                                          <>
                                                            {cCharge?.ValueType ===
                                                            0
                                                              ? "₹ "
                                                              : ""}
                                                            {cCharge?.Value}
                                                            {cCharge?.ValueType ===
                                                            1
                                                              ? "%"
                                                              : ""}
                                                          </>
                                                        )}
                                                      </td>
                                                    </tr>
                                                  );
                                                }
                                              )}
                                              <tr className="cancel-row">
                                                <td
                                                  className="cancel-td"
                                                  colSpan={5}
                                                >
                                                  <strong className="d-block">
                                                    *From the Time of Departure
                                                  </strong>
                                                  <strong>
                                                    *Service charge will be
                                                    extra
                                                  </strong>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    )}
                                    {rescheduleCharges?.length > 0 && (
                                      <div className="cancel-wrapper">
                                        <div className="cancel-table-container">
                                          <table className="cancel-table">
                                            <thead>
                                              <tr>
                                                <th
                                                  colSpan={5}
                                                  className="cancel-th"
                                                >
                                                  <h4>Reschedule Charges</h4>
                                                </th>
                                              </tr>
                                              <tr>
                                                <th className="cancel-th">#</th>
                                                <th className="cancel-th">
                                                  Applicability
                                                </th>
                                                <th className="cancel-th">
                                                  Passenger Type
                                                </th>
                                                <th className="cancel-th">
                                                  Duration
                                                </th>
                                                <th className="cancel-th">
                                                  Charge
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {rescheduleCharges?.map(
                                                (
                                                  rCharge: any,
                                                  index: number
                                                ) => {
                                                  return (
                                                    <tr className="cancel-row">
                                                      <td className="cancel-td">
                                                        {index + 1}
                                                      </td>
                                                      <td className="cancel-td">
                                                        <span className="cancel-pill">
                                                          Per{" "}
                                                          {rCharge?.Applicablility ===
                                                          0
                                                            ? "Segment"
                                                            : "Passenger"}
                                                        </span>
                                                      </td>
                                                      <td className="cancel-td">
                                                        {rCharge?.PassengerType ===
                                                        0
                                                          ? "Adult"
                                                          : rCharge?.PassengerType ===
                                                            1
                                                          ? "Child"
                                                          : "Infant"}
                                                      </td>
                                                      <td className="cancel-td">
                                                        {rCharge?.DurationFrom}{" "}
                                                        {rCharge?.DurationTypeFrom ===
                                                        0
                                                          ? "Hr(s) "
                                                          : rCharge?.DurationTypeFrom ===
                                                            1
                                                          ? "days "
                                                          : ""}{" "}
                                                        – {rCharge?.DurationTo}{" "}
                                                        {rCharge?.DurationTypeTo ===
                                                        0
                                                          ? "Hr(s)"
                                                          : rCharge?.DurationTypeTo ===
                                                            1
                                                          ? "days"
                                                          : ""}
                                                      </td>
                                                      <td className="cancel-td">
                                                        {+rCharge?.Value ===
                                                        0 ? (
                                                          "Non Chargeable"
                                                        ) : +rCharge?.Value ===
                                                            100 &&
                                                          rCharge?.ValueType ===
                                                            1 ? (
                                                          "Non Refundable"
                                                        ) : (
                                                          <>
                                                            {rCharge?.ValueType ===
                                                            0
                                                              ? "₹ "
                                                              : ""}
                                                            {rCharge?.Value}
                                                            {rCharge?.ValueType ===
                                                            1
                                                              ? "%"
                                                              : ""}
                                                          </>
                                                        )}
                                                      </td>
                                                    </tr>
                                                  );
                                                }
                                              )}
                                              <tr className="cancel-row">
                                                <td
                                                  className="cancel-td"
                                                  colSpan={5}
                                                >
                                                  <strong className="d-block">
                                                    *From the Time of Departure
                                                  </strong>
                                                  <strong>
                                                    *Service charge will be
                                                    extra
                                                  </strong>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                )}
                                <div className="travel-detail-btns mt-4">
                                  <a
                                    className="btn disable"
                                    href="javascript:void(0)"
                                    data-bs-dismiss="modal"
                                  >
                                    Close
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="modal fade"
                          id="cancellation-confirmation"
                          data-bs-backdrop="static"
                          data-bs-keyboard="false"
                          tabIndex={-1}
                          aria-labelledby="cancellation-confirmation"
                          aria-hidden="true"
                        >
                          <div
                            className="modal-dialog modal-dialog-centered"
                            style={{ maxWidth: 500 }}
                          >
                            <div className="modal-content position-relative">
                              <Loading loading={fetchLoading} />
                              <div className="modal-header">
                                <h4
                                  className="modal-title fs-5"
                                  id="edit-profile"
                                >
                                  Review Your Booking to be Cancelled
                                </h4>
                              </div>
                              <div className="modal-body travel-form-detail">
                                <div className="dialog-box">
                                  <ul
                                    style={{
                                      listStyle: "auto",
                                      paddingLeft: 20,
                                    }}
                                  >
                                    {paxDetails?.map((pax: any) => {
                                      return (
                                        <li style={{ listStyle: "auto" }}>
                                          <span
                                            style={{
                                              fontSize: "16px",
                                              fontWeight: "600",
                                            }}
                                          >
                                            {pax?.passanger_name}
                                          </span>
                                          <span
                                            style={{
                                              fontSize: "14px",
                                              fontWeight: "600",
                                            }}
                                          >
                                            {" - "}
                                            {pax?.journey_type}
                                          </span>
                                        </li>
                                      );
                                    })}
                                  </ul>
                                </div>
                                <div className="travel-detail-btns mt-4">
                                  <a
                                    className="disable back-btn"
                                    href="javascript:void(0)"
                                    data-bs-dismiss="modal"
                                    ref={closeBtnRef}
                                    // onClick={() => formik.resetForm()}
                                  >
                                    Cancel
                                  </a>
                                  <a
                                    className="booking-cancel-btn"
                                    href="javascript:void(0)"
                                    onClick={() => handleCancelBooking()}
                                  >
                                    Confirm
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                }
              )}
            <div className="mt-4 mb-3 header-label d-flex justify-content-end gap-3">
              <button
                className="back-btn"
                onClick={() => navigate("/flights/mytrips")}
              >
                Back
              </button>
              <button
                className="booking-cancel-btn"
                {...(checkList.length > 0 && {
                  "data-bs-toggle": "modal",
                  "data-bs-target": `#cancellation-confirmation`,
                })}
                onClick={() => {
                  if (checkList.length <= 0) {
                    ErrorToast(
                      "Please select at least one pax for cancellation"
                    );
                    return;
                  }
                }}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BookingCancellation;
